export const DEFAULTS = {
    // colors property-namn används för labels till <ColorPicker>, därför på svenska
    colors: {
        start: "#94b5c9",
        väg: "#ffffff",
        färdig: "#89e66f",
        aktiv: "#dd0069",
        väggar: "#000000",
    },
    speed: 150,
    size: 10,
}